import React from 'react';
import Helmet from 'react-helmet';

const ErrorPage = () => {
    return (
        <div className="container">
            <Helmet title="Error 404: Not Found" />
            <div className="l-text-center l-skinny">
                <h2 className="spaced-single">Woah! We know this page was here just a second ago!</h2>

                <p className="spaced-single">
                    Please contact <a href="mailto:WebDevelopmentTeam@findaway.com">WebDev</a> for assistance and we'll
                    work on getting this page up and running again.
                </p>

                <p>Thank you!</p>
            </div>
        </div>
    );
};

export default React.memo(ErrorPage);
